import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";
function BinTransfer_Breadcrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="bintransfer-breadcrumb container-fluid ">
      {vPathName === "/BinTransferData" ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Bin Transfer Data{" "}
          </span>
        </div>
      ) : vPathName === "/BinTrnasferForm" ? (
        <div className="d-flex">
          <Link
            to="/BinTransferData"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            Bin Transfer Data
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              Bin Transfer Form{" "}
            </span>
          </div>
        </div>
      ) : vPathName === "/BinTransfer/Out" ||
        vPathName === "/BinTransfer/In" ? (
        <div className="d-flex align-items-center">
          <Link
            to="/BinTransferData"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            Bin Transfer Data
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <Link
            to="/BinTrnasferForm"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active  mr-2"}
          >
            Bin Transfer Form
          </Link>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default BinTransfer_Breadcrumbs;
